function VideoStudy() {
  return <div>Video study Israel</div>;
}

export default VideoStudy;
